import type { TFunction } from 'i18next';
import type { U2000TableColumn } from '../../../u2000Core/components/tables/basic/U2000BasicTableList';
import { U2000_CRITERIA_LOOKUP_U3121_FIND_PROJECT } from '../../../u2000Core/components/tables/commons/search/U2000CriteriaLookupRegistry';

const NS = 'u3500';

/** Colonnes liste + critères U3500 (BL-0489). */
export function getU3500DocumentSearchColumnsDef(t: TFunction): U2000TableColumn[] {
  return [
    {
      name: 'orphan',
      label: t('lblOrphan', { ns: NS }),
      widthClass: 'w-[100px]',
      type: 'boolean',
      align: 'center',
      inGridField: false,
      isDefaultColumn: false,
      sortable: false,
      isCriteriaField: true,
      includeConditions: ['equals', 'notequals'],
    },
    {
      name: 'projetNumber',
      label: t('lblProjetNumber', { ns: NS }),
      widthClass: 'w-[120px]',
      type: 'string',
      align: 'left',
      inGridField: true,
      isDefaultColumn: true,
      sortable: true,
      isDefaultSortedColumn: true,
      isCriteriaField: true,
      includeConditions: ['equals', 'notequals', 'in'],
      criteriaLookup: {
        findMethod: U2000_CRITERIA_LOOKUP_U3121_FIND_PROJECT,
        searchCriterionField: 'projetNumber',
        valueKey: 'projetNumber',
        displayKeys: ['projetNumber', 'projetName'],
        selectedDisplayKeys: ['projetNumber', 'projetName'],
        placeholder: t('phCriteriaProject', { ns: 'common' }),
      },
    },
    {
      name: 'projetName',
      label: t('lblProjetName', { ns: NS }),
      widthClass: 'w-[220px]',
      type: 'string',
      align: 'left',
      inGridField: true,
      isDefaultColumn: true,
      sortable: false,
      isCriteriaField: false,
    },
    {
      name: 'relativePath',
      label: t('lblRelativePath', { ns: NS }),
      widthClass: 'w-[360px]',
      type: 'string',
      align: 'left',
      inGridField: true,
      isDefaultColumn: true,
      sortable: false,
      isCriteriaField: false,
    },
    {
      name: 'fileName',
      label: t('lblFileName', { ns: NS }),
      widthClass: 'w-[220px]',
      type: 'string',
      align: 'left',
      inGridField: true,
      isDefaultColumn: true,
      sortable: true,
      isCriteriaField: true,
      includeConditions: ['equals', 'startswith', 'contains', 'endswith'],
    },
  ];
}
